import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  // url: string = "http://support.appsradiant.com/api_myRadiant_trial"; //Trial
  // url: string = 'http://localhost/radiant/mobile-api';
  // url : string = 'http://192.168.1.58:88'; //
  // url: string = 'http://localhost/API/myradiant';  //->LOCALHOST
  // url: string = "http://localhost/RUIS/api_myRadiant"; //->MY LOCALHOST
  // url: string = 'http://202.182.55.114:8011/api_myradiant'; // Server Traspac 11
  // url: string = 'http://192.168.1.61/produksi/radiant/api/'; //-> Dev Traspac IP
  // url: string = 'http://192.168.1.146:80/api/api_myradiant_public'; //-> Dev Traspac IP
  // url: string = 'http://172.31.1.53:88/api/api_myradiant_public'; //-> Dev Traspac IP in Radiant
  // url: string = 'http://192.168.43.185:88/api/api_myradiant_public'; //-> Dev Traspac IP
  // url:string ='http://192.168.1.118/api/api_radiant';
  // url: string = 'http://202.147.194.34/api_trial';
  // url: string = 'http://202.147.194.34/api_brawijaya';
  // url_erp:string = 'http://192.168.1.61/produksi/erp/dev_fauzi/api/index.php/service_library'; //lokal
  // url_erp:string = 'http://202.182.55.114:7011/radiant/erp/api/index.php/service_library'; //public

  // url: string = "http://172.24.3.15/app/api_myRadiant"; //Live private
  url: string = "https://support.appsradiant.com/api_myRadiant"; //Live public

  // url_erp: string = "http://172.24.3.15/app/api/index.php/service_library"; //private
  url_erp: string = "https://support.appsradiant.com/api/index.php/service_library"; //public
 
  url_opencage = "https://api.opencagedata.com/"; 
  // url_erp:string = 'http://192.168.1.11:8011/radiant/erp/api/index.php/service_library'; //traspac local

  constructor(public http: HttpClient) { }

  getOri(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(this.url + "/" + endpoint, reqOpts);
  }

  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }
    reqOpts.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    });
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(this.url + "/" + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any) {
    if (reqOpts == undefined) {
      reqOpts = {};
    }
    reqOpts.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    });
    let params = this.serialize(body);
    return this.http.post(this.url + "/" + endpoint, params, reqOpts);
  }

  postCustomUrl(url: string, body: any, reqOpts?: any) {
    if (reqOpts == undefined) {
      reqOpts = {};
    }
    reqOpts.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    });
    let params = this.serialize(body);
    return this.http.post(url, params, reqOpts);
  }

  getCustomUrl(url: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }
    reqOpts.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    });
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(url, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + "/" + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.url + "/" + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.patch(this.url + "/" + endpoint, body, reqOpts);
  }

  serialize(obj) {
    var str = "";
    for (var key in obj) {
      if (str != "") {
        str += "&";
      }
      str += key + "=" + encodeURIComponent(obj[key]);
    }
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts